import { Component, OnInit, OnDestroy } from '@angular/core';
import { Input, Output, EventEmitter }  from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

import { Ticket } from '@app/modules/model/ticket';
import { TicketDiscount } from '@app/modules/model/ticketdiscount';
import { Discount } from '@app/modules/model/discount';

import { languageSupport, languageService } from '@app/modules/common/language'
import { viewService } from '@app/modules/view';

@Component({
    selector: 'ui-ticket-discount',
    templateUrl:'./ui-ticket.html',
    styleUrls: [ 
        './ui-ticket.scss'
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiTicketDiscount extends languageSupport implements OnInit, OnDestroy {
    @Input('discount') _discount: TicketDiscount = null;
    @Input('refund') _refund: boolean = false;

    private _subscriptions = [];

    get ToCharge(){
        return this._discount.charge - this._discount.refund;
    }

    get ToRefund(){
        return this._discount.refund;
    }

    /***********************************/
    /* STARTS HERE                     */
    /***********************************/

    constructor(private lang: languageService, private change: ChangeDetectorRef, public view: viewService) {
        super(lang, change);
    }

    ngOnInit(){
        this._subscriptions.push(
            this.view.OnTheme.subscribe(
            data => {
                this.change.markForCheck();
            })
        );  

        this._subscriptions.push(
            this._discount.ticket.OnRefresh.subscribe(
            data => {
                this.change.markForCheck();
            })
        );    

        this._subscriptions.push(
            this._discount.OnRefresh.subscribe(
            data => {
                this.change.markForCheck();
            })
        );    
    }

    ngOnDestroy(){
        super.OnDestroy();

        for(let _subscription of this._subscriptions){
            _subscription.unsubscribe();
        }
        this._subscriptions = [];
    }
}
